import type { SirApiType } from '@tempo-io/sir-app/rpc';
import { createHonoRpcClient } from './hono-rpc-client';

export const getSirServiceApi = createHonoRpcClient<SirApiType>('/api/sir/v1/');
